import { Button, ButtonProps } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface EditButtonLinkProps extends ButtonProps {
  to?: string;
}

export function EditButtonLink(props: EditButtonLinkProps) {
  const { to, ...buttonProps } = props;
  const { t } = useTranslation();

  return (
    <Button
      {...buttonProps}
      leftSection={<IconEdit size={16} />}
      component={Link}
      to={to ?? 'edit'}
    >
      {t('button.edit')}
    </Button>
  );
}
